import { RootState } from '@/store/main';

export const selectBccEmails = (state: RootState) => state.channelSettings.bccEmails;
export const selectRedirects = (state: RootState) => state.channelSettings.redirects;
export const selectProjectAlertEmails = (state: RootState) => state.channelSettings.projectAlertEmails;
export const selectShowEditChannelDetailsModal = (state: RootState) =>
  state.channelSettings.showEditChannelDetailsModal;
export const selectShowEditPrimaryContactModal = (state: RootState) =>
  state.channelSettings.showEditPrimaryContactModal;
export const selectShowEditEmailSettingsModal = (state: RootState) => state.channelSettings.showEditEmailSettingsModal;
export const selectShowRedirectModal = (state: RootState) => state.channelSettings.showRedirectModal;
export const selectApiKeys = (state: RootState) => state.channelSettings.apiKeys;
export const selectLoadingApiKeys = (state: RootState) => state.channelSettings.loadingApiKeys;

export const selectChannelInstances = (state: RootState) => state.channelSettings.channelInstances;
export const selectTrayUser = (state: RootState) => state.channelSettings.trayUser;
export const selectSolutions = (state: RootState) => state.channelSettings.solutions;
export const selectSolutionsMapped = (state: RootState) => state.channelSettings.solutionsMapped;
export const selectSolutionInstances = (state: RootState) => state.channelSettings.solutionInstances;
export const selectInstanceToCreate = (state: RootState) => state.channelSettings.instanceToCreate;
export const selectOAuthIntegration = (state: RootState) => state.channelSettings.oauthIntegration;
export const selectStripe = (state: RootState) => state.channelSettings.stripe;
export const selectShowStripeModal = (state: RootState) => state.channelSettings.showStripeModal;
export const selectShowSelectIntegrationModal = (state: RootState) => state.channelSettings.showSelectIntegrationModal;
export const selectShowUpsertIntegrationModal = (state: RootState) => state.channelSettings.showUpsertIntegrationModal;
export const selectIntegrationNameToAdd = (state: RootState) => state.channelSettings.integrationNameToAdd;
export const selectShowHiveModal = (state: RootState) => state.channelSettings.showHiveModal;
export const selectShowKollectiveModal = (state: RootState) => state.channelSettings.showKollectiveModal;
export const selectInboundIntegrationToEdit = (state: RootState) => state.channelSettings.inboundIntegrationToEdit;
